module.exports = __webpack_public_path__ + "static/img/jcICON4.03ea809.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/data/jcICON4.png
// module id = M8q/
// module chunks = 49